import * as moment from 'moment';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SalesPortalService } from 'src/app/services/sales-portal.service';

@Component({
  selector: 'turnover',
  templateUrl: './turnover.component.html',
  styleUrls: ['./turnover.component.less'],
})
export class TurnoverComponent implements OnInit {
  targetYear: string = '';
  searchFormData!: FormGroup;
  isSpinning: boolean = false;
  listOfData: any = [];

  sortFn = {
    turnoverTarget: (a: any, b: any) =>
      a.targetProcurement - b.targetProcurement,
    ytdTurnoverTarget: (a: any, b: any) => a.ytdProcurement - b.ytdProcurement,
    currentTurnover: (a: any, b: any) =>
      a.actualProcurement - b.actualProcurement,
    stillToGo: (a: any, b: any) =>
      a.procurementStillToGo - b.procurementStillToGo,
  };

  constructor(
    private fb: FormBuilder,
    private router: Router,
    public salesPortalService: SalesPortalService
  ) {}

  ngOnInit(): void {
    document.body.classList.add('sales-portal-body');
    this.targetYear = String(moment().year());

    this.searchFormData = this.fb.group({
      searchStr: ['', []],
      procurementTargetAchieved: ['', []],
      procurementConfigurationCompleted: ['', []],
    });

    this.getList();
    this.getSummary();
  }

  ngOnDestroy(): void {
    document.body.classList.remove('sales-portal-body');
  }

  get scrollX() {
    return window.innerWidth + 200 + 'px';
  }

  getList() {
    const params = {
      targetYear: this.targetYear,
      ...this.searchFormData.value,
    };
    this.isSpinning = true;
    this.salesPortalService.dealerTargetList(params).subscribe(
      (result: any) => {
        const { rtnCode, rtnData } = result;
        if (rtnCode === 10000) {
          this.listOfData = rtnData;
        }
        this.isSpinning = false;
      },
      () => {
        this.isSpinning = false;
      }
    );
  }

  getSummary() {
    this.salesPortalService.dealerTargetSummary({
      targetYear: this.targetYear,
      dealerCode: '',
      dealerOrgCode: '',
      dealerChannelCode: '',
    });
  }

  handleDateChange(result: Date) {
    this.targetYear = String(moment(result).year());
    this.getList();
    this.getSummary();
  }

  handleSearch(): void {
    this.getList();
  }

  handleToDetail(data: any) {
    this.router.navigate(['/sales-portal/turnover/detail'], {
      queryParams: {
        targetYear: this.targetYear,
        dealerCode: data.dealerCode,
        dealerOrgCode: data.dealerOrgCode,
        dealerChannelCode: data.dealerChannelCode,
      },
    });
  }

  handleToSetting(data: any) {
    this.router.navigate(['/sales-portal/turnover/setting'], {
      queryParams: {
        targetYear: this.targetYear,
        dealerCode: data.dealerCode,
        dealerOrgCode: data.dealerOrgCode,
        dealerChannelCode: data.dealerChannelCode,
      },
    });
  }
}
